<template>
  <div class="answer" v-if="chatgptanswer">
    <Spinner
      :isLoading="isLoading"
      :error="error"
      :textLoading="texts.hamtarAiSvar"
      :textError="texts.aiSvarMisslyckades"
      :textLoaded="texts.aiSvarHamtat"
    ></Spinner>
    <p v-if="!isLoading && chatgptanswer" v-html="chatgptanswer"></p>
  </div>
</template>
<script>
import Spinner from "../../helpers/spinner.vue";
export default {
  name: "ChatAnswer",
  props: {
    chatgptanswer: [Array, String], // Tillåt både Array och String
    texts: Object,
    isLoading: Boolean,
    error: Boolean,
  },
  components: {
    Spinner,
  },
};
</script>
